<template>
  <div>
    <div>
      <AlertBox ref="alertBox" />
      <NavBar />
      <!-- UserPage content here -->
      <div
        id="floating-box"
        :class="{ 'floating-box--collapsed': !isExpanded }"
      >
        <div id="floating-header" @click="toggleFloatingBox">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="header-label" style="min-width: 100px">
              <span class="d-none d-md-inline text-black">สถานะการกู้:</span>
              <i
                class="fas fa-info-circle d-inline d-md-none"
                style="color: #964040"
              ></i>
            </div>
            <div
              class="status-text d-none d-md-inline fw-bold px-2 rounded-2"
              id="info_loan_status"
            ></div>
            <i
              id="toggle-arrow"
              style="color: #964040"
              class="fas fa-chevron-down"
              :class="{ rotated: isExpanded }"
            ></i>
          </div>
        </div>

        <transition name="fold">
          <div id="floating-content" v-show="isExpanded">
            <div class="d-block d-md-none mb-2">
              <span class="fw-bold">สถานะการกู้:</span>
              <span id="info_loan_status_mobile"></span>
            </div>
            <div>
              <span class="fw-bold">ดูแลโดย:</span>
              <div id="Info_managed_by" class="mt-1"></div>
            </div>
            <div>
              <span class="fw-bold">รายละเอียด:</span>
              <div id="Info_loan_details" class="mt-1"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="red-circle shadow"></div>
    <div class="screen-control">
      <!-- สถานะการกู้ -->
      <div class="p-3 text-black">
        <div class="bg-white shadow">
          <div class="p-2 row">
            <div class="col">
              <h5 class="my-auto p-2">ข้อมูลคำขอ</h5>
            </div>
            <div class="col-md my-auto mx-2">
              <div class="float-end">
                <button
                  class="btn border-0"
                  @click="getPDFpersonalData(ID, studentID)"
                >
                  <i class="fa-solid fa-file-pdf" style="color: #964040"></i>
                </button>
              </div>
            </div>
          </div>

          <hr
            style="border: none; height: 2px; background-color: black"
            class="p-0 m-0"
          />

          <!-- User Info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลผู้กู้ยืมเงิน</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="mb-4">
                <p class="col"><b>รูปนักศึกษา</b></p>
                <div
                  v-if="imageUrl()"
                  :style="{
                    width: '200px',
                    aspectRatio: '4 / 3',
                    backgroundImage: `url(${imageUrl()})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                  }"
                ></div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>ชื่อ-นามสกุล</b></p>
                    <p class="col-12 col-md" id="Info_user_fullname">-</p>
                  </div>
                </div>

                <div class="col-12 col-md">
                  <div class="row">
                    <p class="col"><b>อายุ</b></p>
                    <p class="col-12 col-md" id="Info_user_old">-</p>
                  </div>
                </div>
              </div>

              <div class="row"></div>

              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>เบอร์โทรศัพท์เคลื่อนที่</b></p>
                    <p class="col-12 col-md" id="Info_user_phoneNumber">-</p>
                  </div>
                </div>

                <div class="col-12 col-md">
                  <div class="row">
                    <p class="col"><b>บัตรประชาชน</b></p>
                    <p class="col-12 col-md" id="Info_user_citizenID">-</p>
                  </div>
                  <div class="row">
                    <div class="col" v-if="user_citizenID_file">
                      <p>
                        <b>{{ ncbDocumentLabel("หนังสือยินยอมพร้อมสำเนาบัตรประชาชนผู้กู้") }}</b>
                      </p>
                    </div>
                    <div
                      class="col-12 col-md"
                      id="Info_user_citizenID_file"
                      v-if="user_citizenID_file"
                    >
                      <a
                        :href="getFileUrl(user_citizenID_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col">
                  <p class="mb-0 text-muted">
                    <b>วันและเวลาที่ยื่นคำขอ:</b>
                    <span id="Info_submissionDateTime">-</span>
                  </p>
                </div>
                <div class="col-12 col-md"></div>
              </div>
            </div>
          </div>

          <!-- User's education info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลการศึกษาที่ขอยื่นกู้</p>
            <div class="bg-secondary-subtle">
              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ระดับการศึกษา</b></p>
                      <p class="col-12 col-md" id="Info_user_lvlStudy">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ปีการศึกษา</b></p>
                      <p class="col-12 col-md" id="Info_user_yearStudy">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>ภาคเรียน</b></p>
                      <p class="col-12 col-md" id="Info_user_semesterStudy">
                        -
                      </p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>สถานภาพการเป็นนักศึกษา</b></p>
                      <div class="col-12 col-md">
                        <p id="Info_user_studentStatus">-</p>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>ประเภทของผู้กู้ยืม</b></p>
                      <div class="col-12 col-md">
                        <p id="Info_user_studentType">-</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row" v-if="user_transcript_file">
                      <div class="col">
                        <p><b>ใบแสดงผลการศึกษาตลอดหลักสูตร (Transcript)</b></p>
                      </div>
                      <div class="col-12 col-md" id="Info_user_transcript_file">
                        <a
                          :href="getFileUrl(user_transcript_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row" v-if="user_studentCertificate_file">
                      <div class="col">
                        <p><b>หนังสือรับรองการเป็นนักศึกษา</b></p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_user_studentCertificate_file"
                      >
                        <a
                          :href="getFileUrl(user_studentCertificate_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col" v-if="user_courseCertificate_file">
                    <div class="row">
                      <div class="col">
                        <p>
                          <b
                            >หนังสือรับรองรายวิชาที่ต้องลงทะเบียนเรียนจากสถานศึกษาประจำปีสุดท้าย</b
                          >
                        </p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_user_courseCertificate_file"
                      >
                        <a
                          :href="getFileUrl(user_courseCertificate_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md"></div>
                </div>

                <div class="row" v-show="show_studentStatus_reason">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>เหตุผลการลาพักการศึกษา</b></p>
                      <div class="col-12 col-md">
                        <p id="Info_user_studentStatus_reason">-</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>สำนักวิชา</b></p>
                      <p class="col-12 col-md" id="Info_user_faculty">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>สาขาวิชา</b></p>
                      <p class="col-12 col-md" id="Info_user_fieldStudy">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>รหัสนักศึกษา</b></p>
                      <p class="col-12 col-md" id="Info_user_studentID">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="row">
                      <div class="col d-flex align-items-start gap-2">
                        <p><b>GPAX</b></p>
                        <button
                          class="btn border-0 m-0 p-0"
                          id="btn-edit-GPAX"
                          @click="editGPAX()"
                        >
                          <i
                            class="fa-solid fa-pen-to-square"
                            style="color: #964040"
                          ></i>
                        </button>
                      </div>

                      <div class="col-12 col-md">
                        <p id="Info_user_gpax">-</p>
                        <div class="col-12 col-md" id="Info_user_gpax_file">
                          <a
                            :href="getFileUrl(user_gpax_file)"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-if="user_gpax_file"
                          >
                            <p class="text-primary text-decoration-underline">
                              คลิกเพื่อดูไฟล์
                            </p>
                          </a>
                          <p v-else>-</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>จบการศึกษาระดับ</b></p>
                      <p class="col-12 col-md" id="Info_user_graduateLvl">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="p-3">
                 <div class="row">
                   <div class="col">
                     <div class="row">
                       <div class="col d-flex align-items-start gap-2">
                         <p>
                           <b>กิจกรรมจากเว็บไซต์ MFU CHARACTER (MFU333) จำนวน</b>
                         </p>
                         <button
                          class="btn border-0 m-0 p-0"
                          id="btn-edit-public-service"
                          @click="
                            editPublicServiceNumber(
                              'Public_Service_Number_MFU333'
                            )
                          "
                        >
                          <i
                            class="fa-solid fa-pen-to-square"
                            style="color: #964040"
                          ></i>
                         </button>
                       </div>
                       <p
                         class="col-12 col-md"
                         id="Info_Public_Service_Number_MFU333"
                       >
                         -
                       </p>
                      </div>
                    </div>
                    <div class="col-12 col-md">
                    <div class="row">
                      <div
                        class="col"
                        id="Info_Public_Service_MFU333_File"
                        v-if="Public_Service_MFU333_File"
                      >
                        <a
                          :href="getFileUrl(Public_Service_MFU333_File)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                      <div class="col-12 col-md"></div>
                    </div>
                   </div>
                 </div>
              </div>

              <div class="px-3 pb-3">
                 <div class="row">
                   <div class="col">
                     <div class="row">
                       <div class="col d-flex align-items-start gap-2">
                         <p><b> กิจกรรมสร้างเอง จำนวน</b></p>
                         <button
                           class="btn border-0 m-0 p-0"
                           id="btn-edit-public-service"
                           @click="
                             editPublicServiceNumber(
                               'Public_Service_Number_selfCreated'
                             )
                           "
                         >
                           <i
                             class="fa-solid fa-pen-to-square"
                             style="color: #964040"
                           ></i>
                         </button>
                       </div>
                       <p
                         class="col-12 col-md"
                         id="Info_Public_Service_Number_selfCreated"
                       >
                         -
                       </p>
                      </div>
                    </div>
                    <div class="col-12 col-md">
                    <div class="row">
                      <div
                        class="col"
                        id="Info_Public_Service_selfCreated_File"
                        v-if="Public_Service_selfCreated_File"
                      >
                        <a
                          :href="getFileUrl(Public_Service_selfCreated_File)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                      <div class="col-12 col-md"></div>
                    </div>
                   </div>
                 </div>
              </div>

              <div class="px-3 pb-3">
                 <div class="row">
                   <div class="col">
                     <div class="row">
                       <div class="col d-flex align-items-start gap-2">
                         <p>
                           <b
                             >เรียน set e-learning, หลักสูตรอื่นๆ ที่กองทุนกำหนด
                             จำนวน</b
                           >
                         </p>
                         <button
                           class="btn border-0 m-0 p-0"
                           id="btn-edit-public-service"
                           @click="
                             editPublicServiceNumber(
                               'Public_Service_Number_eLearning'
                             )
                           "
                         >
                           <i
                             class="fa-solid fa-pen-to-square"
                             style="color: #964040"
                           ></i>
                         </button>
                       </div>
                       <p
                         class="col-12 col-md"
                         id="Info_Public_Service_Number_eLearning"
                       >
                         -
                       </p>
                      </div>
                    </div>
                    <div class="col-12 col-md">
                    <div class="row">
                      <div
                        class="col"
                        id="Info_Public_Service_eLearning_File"
                        v-if="Public_Service_eLearning_File"
                      >
                        <a
                          :href="getFileUrl(Public_Service_eLearning_File)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                      <div class="col-12 col-md"></div>
                   </div>
                 </div>
              </div>
              </div>

              <div class="row px-3 py-2 public-service-total-row">
                <div class="col">
                  <div class="row">
                    <p class="col public-service-total-row__label"><b>รวม</b></p>
                    <p class="col-12 col-md public-service-total-row__value">
                      <b id="info_totalPublicService">-</b>
                    </p>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>
            </div>
          </div>

          <!-- User's fiance info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลการเงิน</p>
            <div class="bg-secondary-subtle">
              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ได้รับค่าใช้จ่ายในชีวิตประจำวัน</b></p>
                      <p class="col-12 col-md" id="Info_dailyFee">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_user_job">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col d-flex align-items-start gap-2">
                        <p class="col"><b>รายได้บาท/ปี</b></p>
                        <!-- <button class="btn border-0 m-0 p-0" id="btn-edit-income" @click="editincome()">
                        <i class="fa-solid fa-pen-to-square" style="color: #964040"></i>
                      </button> -->
                      </div>

                      <p class="col-12 col-md" id="Info_income">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ได้รับทุนการศึกษาจาก</b></p>
                      <p
                        class="col-12 col-md"
                        id="Info_user_scholarship_income"
                      >
                        -
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ผู้กู้มีบัตรสวัสดิการแห่งรัฐ หรือไม่</b></p>
                      <p class="col-12 col-md" id="Info_has_welfare_card">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row" v-if="welfare_card_file">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ไฟล์บัตรสวัสดิการแห่งรัฐ</b></p>
                      <div class="col-12 col-md">
                        <a
                          :href="getFileUrl(welfare_card_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ผู้กู้เคยรับทุนการศึกษา กองทุนเพื่อความเสมอภาคทางการศึกษา (กสศ.) หรือไม่</b></p>
                      <p class="col-12 col-md" id="Info_has_eef_scholarship">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row" v-if="eef_scholarship_file">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ไฟล์ทุนการศึกษา กสศ.</b></p>
                      <div class="col-12 col-md">
                        <a
                          :href="getFileUrl(eef_scholarship_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row" v-show="income_file">
                  <div class="col">
                    <div class="row">
                      <p class="col">
                        <b
                          >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือน") }}</b
                        >
                      </p>
                      <div
                        class="col-12 col-md"
                        id="Info_income_file"
                        v-if="income_file"
                      >
                        <a
                          :href="getFileUrl(income_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="row p-3">
                <div class="col">
                  <div class="row">
                    <p class="col">
                      <b> มีความประสงค์จะขอกู้ยืม<br />เพื่อใช้ในการศึกษา</b>
                    </p>
                    <p class="col-12 col-md" id="Info_loanPurpose">-</p>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="row p-3">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>ลักษณะของผู้กู้ยืม</b></p>
                    <p class="col-12 col-md" id="Info_user_loanType">-</p>
                  </div>
                </div>
                <div class="col-12 col-md" id="loanType_checkbox"></div>
              </div>
            </div>
          </div>

          <!-- User's fan info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลคู่สมรส</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>สถานะ</b></p>
                    <p class="col-12 col-md" id="Info_fan_status">-</p>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>
              <div class="row" v-show="fan_file">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>ไฟล์เอกสารสมรส</b></p>
                    <div class="col-12 col-md" id="Info_fan_file">
                      <a
                        :href="getFileUrl(fanFile)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="fanFile"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div v-show="show_fan_info">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ชื่อ-นามสกุล </b></p>
                      <p class="col-12 col-md" id="Info_fan_fullname">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อายุ</b></p>
                      <p class="col-12 col-md" id="Info_fan_old">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col">
                        <b>เบอร์โทรศัพท์เคลื่อนที่</b>
                      </p>
                      <p class="col-12 col-md" id="Info_fan_phoneNumber">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>เลขบัตรประชาชน</b></p>
                      <p class="col-12 col-md" id="Info_fan_citizenID">-</p>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p>
                          <b>หนังสือยินยอมพร้อมสำเนาบัตรประชาชน</b>
                        </p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_fan_citizenID_file"
                        v-if="fan_citizenID_file"
                      >
                        <a
                          :href="getFileUrl(fan_citizenID_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อีเมล</b></p>
                      <p class="col-12 col-md" id="Info_fan_email">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_fan_job">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>มีรายได้บาท/ปี</b></p>
                      <p class="col-12 col-md" id="Info_fan_income">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b
                          >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนคู่สมรส/บัตรสวัสดิการแห่งรัฐ") }}</b
                        >
                      </p>
                      <div class="col-12 col-md" id="Info_fan_income_file">
                        <a
                          :href="getFileUrl(fan_income_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="fan_income_file"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Siblings Info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลพี่น้อง (ไม่รวมผู้กู้ยืม)</p>
            <div
              class="p-3 bg-secondary-subtle"
              v-if="siblings && siblings.length > 0"
            >
              <div
                v-for="(sibling, idx) in siblings"
                :key="idx"
                class="mb-3 border-bottom pb-2"
              >
                <div class="fw-bold">พี่น้องคนที่ {{ idx + 1 }}</div>
                <div>
                  สถานะ:
                  {{
                    sibling.status === "working"
                      ? "ทำงานแล้ว"
                      : sibling.status === "studying"
                      ? "กำลังศึกษา"
                      : "-"
                  }}
                </div>
                <div v-if="sibling.status === 'working'">
                  อาชีพ: {{ sibling.job || "-" }}<br />
                  รายได้ต่อปี: {{ sibling.income || "-" }} บาท
                </div>
                <div v-if="sibling.status === 'studying'">
                  ระดับการศึกษา: {{ sibling.educationLevel || "-" }}
                </div>
              </div>
            </div>
            <div v-else class="p-3 bg-secondary-subtle text-muted">
              ไม่มีข้อมูลพี่น้อง
            </div>
          </div>

          <!-- User's father info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลบิดา</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>สถานะ</b></p>
                    <p class="col-12 col-md" id="Info_dad_status">-</p>
                  </div>
                </div>

                <div class="col-12 col-md"></div>
              </div>

              <div class="row" v-show="dad_death_certificate_file">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <div class="row">
                        <p class="col"><b>ชื่อ-นามสกุล</b></p>
                        <p class="col-12 col-md" id="Info_dad_fullname_dead">
                          -
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <p class="col"><b>ใบมรณะบัตรของบิดา</b></p>
                    <div
                      class="col-12 col-md"
                      id="Info_dad_death_certificate_file"
                    >
                      <a
                        :href="getFileUrl(dad_death_certificate_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="dad_death_certificate_file"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div class="row" v-show="dad_family_status_certificate_file">
                <div class="col">
                  <div class="row">
                    <p class="col">
                      <b
                        >ไฟล์หนังสือรับรองสถานภาพครอบครัวพร้อมสำเนาบัตรข้าราชการ</b
                      >
                    </p>
                    <div
                      class="col-12 col-md"
                      id="Info_dad_family_status_certificate_file"
                    >
                      <a
                        :href="getFileUrl(dad_family_status_certificate_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="dad_family_status_certificate_file"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div v-show="show_dad_info">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ชื่อ-นามสกุล</b></p>
                      <p class="col-12 col-md" id="Info_dad_fullname">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อายุ</b></p>
                      <p class="col-12 col-md" id="Info_dad_old">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>เลขบัตรประชาชน</b></p>
                      <p class="col-12 col-md" id="Info_dad_citizenID">-</p>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p>
                          <b>หนังสือยินยอมพร้อมสำเนาบัตรประชาชน</b>
                        </p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_dad_citizenID_file"
                        v-if="dad_citizenID_file"
                      >
                        <a
                          :href="getFileUrl(dad_citizenID_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b>เบอร์โทรศัพท์เคลื่อนที่</b>
                      </p>
                      <p class="col-12 col-md" id="Info_dad_phoneNumber">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อีเมล</b></p>
                      <p class="col-12 col-md" id="Info_dad_email">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_dad_job">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>มีรายได้บาท/ปี</b></p>
                      <p class="col-12 col-md" id="Info_dad_income">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b
                          >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนบิดา/บัตรสวัสดิการแห่งรัฐ") }}</b
                        >
                      </p>
                      <div class="col-12 col-md" id="Info_dad_file">
                        <a
                          :href="getFileUrl(dadFile)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="dadFile"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- User's mother info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลมารดา</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>สถานะ</b></p>
                    <p class="col-12 col-md" id="Info_mom_status">-</p>
                  </div>
                </div>

                <div class="col"></div>
              </div>

              <div class="row" v-show="mom_death_certificate_file">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <div class="row">
                        <p class="col"><b>ชื่อ-นามสกุล</b></p>
                        <p class="col-12 col-md" id="Info_mom_fullname_dead">
                          -
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <p class="col"><b>ใบมรณะบัตรของมารดา</b></p>
                    <div
                      class="col-12 col-md"
                      id="Info_mom_death_certificate_file"
                    >
                      <a
                        :href="getFileUrl(mom_death_certificate_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="mom_death_certificate_file"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div class="row" v-show="mom_family_status_certificate_file">
                <div class="col">
                  <div class="row">
                    <p class="col">
                      <b>หนังสือรับรองสถานภาพครอบครัวพร้อมสำเนาบัตรข้าราชการ</b>
                    </p>
                    <div
                      class="col-12 col-md"
                      id="Info_mom_family_status_certificate_file"
                    >
                      <a
                        :href="getFileUrl(mom_family_status_certificate_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="mom_family_status_certificate_file"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div v-show="show_mom_info">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ชื่อ-นามสกุล</b></p>
                      <p class="col-12 col-md" id="Info_mom_fullname">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อายุ</b></p>
                      <p class="col-12 col-md" id="Info_mom_old">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>เลขบัตรประชาชน</b></p>
                      <p class="col-12 col-md" id="Info_mom_citizenID">-</p>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p>
                          <b>หนังสือยินยอมพร้อมสำเนาบัตรประชาชน</b>
                        </p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_mom_citizenID_file"
                        v-if="mom_citizenID_file"
                      >
                        <a
                          :href="getFileUrl(mom_citizenID_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b>เบอร์โทรศัพท์เคลื่อนที่ </b>
                      </p>
                      <p class="col-12 col-md" id="Info_mom_phoneNumber">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อีเมล</b></p>
                      <p class="col-12 col-md" id="Info_mom_email">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_mom_job">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>มีรายได้บาท/ปี</b></p>
                      <p class="col-12 col-md" id="Info_mom_income">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b
                          >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนมารดา/บัตรสวัสดิการแห่งรัฐ") }}</b
                        >
                      </p>
                      <div class="col-12 col-md" id="Info_mom_file">
                        <a
                          :href="getFileUrl(momFile)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="momFile"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- dad mom mariage info -->
          <div class="p-3">
            <p class="text-secondary">สถานภาพสมรสของบิดา-มารดา</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>สถานะ</b></p>
                    <p class="col-12 col-md" id="Info_mariage_status">-</p>
                  </div>
                </div>
                <div class="col"></div>
              </div>

              <div class="row" v-if="maritalFile">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>เอกสาร</b></p>
                    <div
                      class="col-12 col-md"
                      id="Info_Marital_status_of_parents_file"
                    >
                      <a
                        :href="getFileUrl(maritalFile)"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>
            </div>
          </div>

          <!-- User's rightful guardian info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลผู้แทนโดยชอบธรรม/ผู้ปกครอง</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>ผู้แทนโดยชอบธรรม/ผู้ปกครอง</b></p>
                    <p class="col-12 col-md" id="Info_rightful_guardian">-</p>
                  </div>
                </div>
                <div class="col-12 col-md">
                  <div class="row">
                    <p class="col"><b>มีความเกี่ยวข้องเป็น</b></p>
                    <p class="col-12 col-md" id="Info_other_relationship">-</p>
                  </div>
                </div>
              </div>

              <div v-show="show_other_info">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ชื่อ-นามสกุล</b></p>
                      <p class="col-12 col-md" id="Info_other_fullname">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อายุ</b></p>
                      <p class="col-12 col-md" id="Info_other_old">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>เลขบัตรประชาชน</b></p>
                      <p class="col-12 col-md" id="Info_other_citizenID">-</p>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p>
                          <b>หนังสือยินยอมพร้อมสำเนาบัตรประชาชน</b>
                        </p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_other_citizenID_file"
                        v-if="other_citizenID_file"
                      >
                        <a
                          :href="getFileUrl(other_citizenID_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b>เบอร์โทรศัพท์เคลื่อนที่</b>
                      </p>
                      <p class="col-12 col-md" id="Info_other_phoneNumber">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อีเมล</b></p>
                      <p class="col-12 col-md" id="Info_other_email">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_other_job">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>มีรายได้บาท/ปี</b></p>
                      <p class="col-12 col-md" id="Info_other_income">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b
                          >{{ ncbDocumentLabel("หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนผู้อุปการะ/บัตรสวัสดิการแห่งรัฐ") }}</b
                        >
                      </p>
                      <div class="col-12 col-md" id="Info_other_file">
                        <a
                          :href="getFileUrl(otherFile)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="otherFile"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col">
                        <b
                          >หนังสือรับรองการเป็นผู้อุปการะที่ไม่ใช่บิดา-มารดาพร้อมสำเนาบัตรข้าราชการ</b
                        >
                      </p>
                      <div class="col-12 col-md" id="Info_other_file">
                        <a
                          :href="getFileUrl(otherFile_certificate)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="otherFile_certificate"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- Description Info -->
          <div class="p-3">
            <p class="text-secondary" id="step5_description_header">
              ความจำเป็นในการขอกู้ยืมเงิน
            </p>
            <div class="p-3 bg-secondary-subtle">
              <div class="col">
                <div class="row">
                  <p
                    class="col"
                    id="step5_description"
                    style="white-space: pre-wrap; word-break: break-word"
                  >
                    {{ loanDescription || "-" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="p-3">
            <p class="text-secondary">แก้ไขรายได้</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="col">
                <div class="row mb-2">
                  <div
                    class="col-12 mb-2"
                    v-if="
                      editIncomes.student !== null &&
                      editIncomes.student !== undefined
                    "
                  >
                    <label>รายได้ผู้กู้ (บาท/ปี)</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="formatNumber(editIncomes.student)"
                      @input="onIncomeInput($event, 'student')"
                      min="0"
                    />
                  </div>
                  <div
                    class="col-12 mb-2"
                    v-if="
                      editIncomes.fan !== null && editIncomes.fan !== undefined
                    "
                  >
                    <label>รายได้คู่สมรส (บาท/ปี)</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="formatNumber(editIncomes.fan)"
                      @input="onIncomeInput($event, 'fan')"
                      min="0"
                    />
                  </div>
                  <div
                    class="col-12 mb-2"
                    v-if="
                      editIncomes.dad !== null && editIncomes.dad !== undefined
                    "
                  >
                    <label>รายได้บิดา (บาท/ปี)</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="formatNumber(editIncomes.dad)"
                      @input="onIncomeInput($event, 'dad')"
                      min="0"
                    />
                  </div>
                  <div
                    class="col-12 mb-2"
                    v-if="
                      editIncomes.mom !== null && editIncomes.mom !== undefined
                    "
                  >
                    <label>รายได้มารดา (บาท/ปี)</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="formatNumber(editIncomes.mom)"
                      @input="onIncomeInput($event, 'mom')"
                      min="0"
                    />
                  </div>
                  <div
                    class="col-12 mb-2"
                    v-if="
                      editIncomes.other !== null &&
                      editIncomes.other !== undefined
                    "
                  >
                    <label>ผู้ปกครองที่ไม่ใช่บิดามารดา (บาท/ปี)</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="formatNumber(editIncomes.other)"
                      @input="onIncomeInput($event, 'other')"
                      min="0"
                    />
                  </div>
                </div>
                <hr />
                <div class="bg-light p-2 rounded mb-2">
                  <label style="font-weight: bold; color: #964040"
                    >รายได้รวมทั้งหมด (บาท/ปี)</label
                  >
                  <p
                    style="
                      font-size: 18px;
                      font-weight: bold;
                      color: #964040;
                      margin: 5px 0;
                    "
                  >
                    {{ totalIncome.toLocaleString() }}
                  </p>
                </div>
                <div class="d-flex gap-2">
                  <button class="btn btn-primary" @click="saveAllIncomes">
                    บันทึก
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="float-end p-3">
            <button class="btn btn-primary shadow" @click="confirmBoxWithValue">
              เปลี่ยนสถานะคำข้อกู้
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/Staff/NavBar_staff.vue";
import AlertBox from "../AlertBox.vue";
import Swal from "sweetalert2";
import { formatEmailDisplayName } from "@/mixins/displayName";
import { getVerifiedZipBlob } from "@/utils/zipDownload";

export default {
  name: "StaffPage_info",
  components: {
    NavBar,
    AlertBox,
  },

  data() {
    return {
      ID: "",
      studentID: "",
      user_studentType: "",
      isExpanded: false,

      show_fan_info: false,
      show_dad_info: false,
      show_mom_info: false,
      show_other_info: false,
      user_citizenID_file: null,
      Public_Service_File: false,
      income_file: null,
      welfare_card_file: null,
      eef_scholarship_file: null,
      show_studentStatus_reason: false,
      pdfDisplayTitle: "",
      pdfMainTitle: "",
      pdfSections: [],

      siblings: [],
      loanDescription: "",

      user_imageFile: null,

      fan_citizenID_file: null,
      fan_income_file: null,
      fanFile: null,
      dadFile: null,
      dad_citizenID_file: null,
      momFile: null,
      mom_citizenID_file: null,
      otherFile: null,
      other_citizenID_file: null,
      Public_Service_MFU333_File: null,
      Public_Service_selfCreated_File: null,
      Public_Service_eLearning_File: null,
      maritalFile: null,
      user_transcript_file: null,
      user_studentCertificate_file: null,
      user_courseCertificate_file: null,
      user_gpax_file: null,
      otherFile_certificate: null,
      dad_death_certificate_file: null,
      mom_death_certificate_file: null,
      dad_family_status_certificate_file: null,
      mom_family_status_certificate_file: null,
      editIncomes: {
        student: null,
        fan: null,
        dad: null,
        mom: null,
        other: null,
      },
    };
  },

  computed: {
    totalIncome() {
      const s = parseFloat(this.editIncomes.student) || 0;
      const f =
        this.show_fan_info && this.editIncomes.fan !== null
          ? parseFloat(this.editIncomes.fan) || 0
          : 0;
      const d =
        this.show_dad_info && this.editIncomes.dad !== null
          ? parseFloat(this.editIncomes.dad) || 0
          : 0;
      const m =
        this.show_mom_info && this.editIncomes.mom !== null
          ? parseFloat(this.editIncomes.mom) || 0
          : 0;
      const o =
        this.show_other_info && this.editIncomes.other !== null
          ? parseFloat(this.editIncomes.other) || 0
          : 0;
      return s + f + d + m + o;
    },
  },

  methods: {
    imageUrl() {
      return this.user_imageFile
        ? `${process.env.VUE_APP_API_BASE_URL}${this.user_imageFile}`
        : null;
    },

    ncbDocumentLabel(label) {
      return this.user_studentType === "รายใหม่" ? `${label}และNCB` : label;
    },

    async getLoanData(value) {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${
            process.env.VUE_APP_API_BASE_URL
          }/staff/get/loan/data?id=${encodeURIComponent(value)}`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        if (response.ok) {
          const staticData = await response.json();
          this.Info_show_data(staticData);
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        this.$refs.alertBox.showAlert(error.message, "error");
      }
    },

    Info_show_data(datas) {
      const formData = datas;
      this.show_fan_info = false;
      this.show_dad_info = false;
      this.show_mom_info = false;
      this.show_other_info = false;
      this.show_studentStatus_reason = false;
      this.siblings = [];
      this.pdfDisplayTitle = formData.pdfDisplayTitle || "";
      this.pdfMainTitle = formData.pdfMainTitle || "";
      this.pdfSections = Array.isArray(formData.pdfSections)
        ? formData.pdfSections
        : [];
      this.user_studentType = formData.user_studentType || "";

      // Helper function to update text content
      const setText = (id, text) => {
        const element = document.getElementById(id);
        if (!element) return;
        if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
          element.value = text ?? "-";
        } else {
          element.innerText = text ?? "-";
        }
      };
      const formatDisplayNumber = (value) => {
        if (value === null || value === undefined || value === "") return "-";
        const normalized = Number(String(value).replace(/,/g, ""));
        return Number.isFinite(normalized) ? normalized.toLocaleString() : value;
      };
      const submissionDateTime = [formData.submission_date, formData.submission_time]
        .filter(Boolean)
        .join(" ");
      this.studentID = formData.user_studentID;
      const setStatus = document.getElementById("info_loan_status");
      // show loan status
      const statusClassMap = {
        อยู่ระหว่างดำเนินการ: "style='color: orange;'",
        ผ่านการตรวจสอบคุณสมบัติ: "class='text-success'",
        อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม: "class='text-secondary'",
        "รอผลการพิจารณาจากกองทุน กยศ.": "class='text-warning'",
        ตีกลับเพื่อแก้เอกสาร: "class='text-primary'",
        อนุมัติ: "style='color: #00cc44;'",
        ไม่อนุมัติ: "class='text-danger'",
      };

      const statusText = formData.loan_status;
      const loanStatusAttr = statusClassMap[statusText] || "";

      setStatus.innerHTML = `<p class="my-auto m-0" ${loanStatusAttr}>${statusText}</p>`;

      // Set show file
      const fileMappings = {
        Public_Service_MFU333_File: "Public_Service_MFU333_File",
        Public_Service_selfCreated_File: "Public_Service_selfCreated_File",
        Public_Service_eLearning_File: "Public_Service_eLearning_File",
        income_file: "income_file",
        welfare_card_file: "welfare_card_file",
        eef_scholarship_file: "eef_scholarship_file",
        fan_citizenID_file: "fan_citizenID_file",
        fan_income_file: "fan_income_file",
        fan_file: "fanFile",
        dad_file: "dadFile",
        dad_citizenID_file: "dad_citizenID_file",
        mom_file: "momFile",
        mom_citizenID_file: "mom_citizenID_file",
        other_file: "otherFile",
        other_citizenID_file: "other_citizenID_file",
        other_NonParent_Custody_Certificate_file: "otherFile_certificate",
        user_citizenID_file: "user_citizenID_file",
        user_gpax_file: "user_gpax_file",
        user_transcript_file: "user_transcript_file",
        user_studentCertificate_file: "user_studentCertificate_file",
        user_courseCertificate_file: "user_courseCertificate_file",
        Marital_status_of_parents_file: "maritalFile",
        dad_death_certificate_file: "dad_death_certificate_file",
        mom_death_certificate_file: "mom_death_certificate_file",
        dad_family_status_certificate_file:
          "dad_family_status_certificate_file",
        mom_family_status_certificate_file:
          "mom_family_status_certificate_file",
        user_imageFile: "user_imageFile",
      };

      Object.keys(fileMappings).forEach((key) => {
        this[fileMappings[key]] = formData[key] || null;
      });

      setText(
        "Info_managed_by",
        this.formatManagedByName(formData.managed_by)
      );
      setText("Info_loan_details", `${formData.loan_details ?? "-"}`);
      // User info
      setText("Info_submissionDateTime", submissionDateTime || "-");
      setText(
        "Info_user_fullname",
        `${formData.user_username} ${formData.user_surname}`
      );
      setText("Info_user_old", formData.user_old);
      setText("Info_user_phoneNumber", formData.user_phoneNumber);
      setText("Info_user_citizenID", formData.user_citizenID);

      // Study info
      const studyFields = [
        "user_lvlStudy",
        "user_yearStudy",
        "user_semesterStudy",
        "user_faculty",
        "user_fieldStudy",
        "user_studentID",
        "user_gpax",
        "user_graduateLvl",
        "user_studentStatus",
        "user_studentStatus_reason",
        "user_studentType",
      ];
      if (formData.user_studentStatus === "ลาพักการศึกษา") {
        this.show_studentStatus_reason = true;
      }

      ["user_loanType"].forEach((field) => {
        setText(`Info_${field}`, formData[field]);
      });

      setText(
        "Info_Public_Service_Number_MFU333",
        `${formData.Public_Service_Number_MFU333} ชั่วโมง`
      );
      setText(
        "Info_Public_Service_Number_selfCreated",
        `${formData.Public_Service_Number_selfCreated} ชั่วโมง`
      );
      setText(
        "Info_Public_Service_Number_eLearning",
        `${formData.Public_Service_Number_eLearning} ชั่วโมง`
      );

      setText(
        "info_totalPublicService",
        `${
          (Number(formData.Public_Service_Number_MFU333) || 0) +
          (Number(formData.Public_Service_Number_selfCreated) || 0) +
          (Number(formData.Public_Service_Number_eLearning) || 0)
        } ชั่วโมง`
      );

      let dailyExpensesOptions = [];
      try {
        dailyExpensesOptions = JSON.parse(formData.daily_expenses_options || "[]");
      } catch (_error) {
        dailyExpensesOptions = [];
      }
      let daily_option = "";
      dailyExpensesOptions.forEach((option) => {
        daily_option += `<p class='m-0'>${option}</p>`;
      });
      document.getElementById(`Info_dailyFee`).innerHTML = daily_option;
      setText("Info_user_job", `${formData.user_job ?? "-"}`);
      setText("Info_income", formatDisplayNumber(formData.user_job_income));
      setText(
        "Info_user_scholarship_income",
        `${formData.user_scholarship_income ?? "-"}`
      );
      setText("Info_has_welfare_card", `${formData.has_welfare_card ?? "-"}`);
      setText(
        "Info_has_eef_scholarship",
        `${formData.has_eef_scholarship ?? "-"}`
      );

      let loanPurposeOptions = [];
      try {
        loanPurposeOptions = JSON.parse(formData.loan_purposes_options || "[]");
      } catch (_error) {
        loanPurposeOptions = [];
      }
      let purpose_option = "";
      loanPurposeOptions.forEach((option) => {
        purpose_option += `<p class='m-0'>${option}</p>`;
      });
      document.getElementById(`Info_loanPurpose`).innerHTML = purpose_option;

      studyFields.forEach((field) => setText(`Info_${field}`, formData[field]));

      // Fan info
      setText(
        "Info_fan_status",
        formData.fan_status === "มีคู่สมรส"
          ? "มีคู่สมรส"
          : formData.fan_status === "โสด"
          ? "โสด"
          : ""
      );
      if (formData.fan_status === "มีคู่สมรส") {
        setText(
          "Info_fan_fullname",
          `${formData.fan_name} ${formData.fan_surname}`
        );
        this.show_fan_info = true;
        [
          "fan_old",
          "fan_citizenID",
          "fan_phoneNumber",
          "fan_email",
          "fan_job",
        ].forEach((field) => {
          setText(`Info_${field}`, formData[field]);
        });
        setText("Info_fan_income", formatDisplayNumber(formData.fan_income));
      }
      // Dad info
      setText(
        "Info_dad_status",
        formData.dad_status === "มีชีวิตอยู่"
          ? "มีชีวิตอยู่"
          : formData.dad_status === "เสียชีวิต"
          ? "เสียชีวิต"
          : "ไม่ทราบ"
      );

      if (formData.dad_status === "มีชีวิตอยู่") {
        setText(
          "Info_dad_fullname",
          `${formData.dad_name} ${formData.dad_surname}`
        );
        this.show_dad_info = true;
        [
          "dad_old",
          "dad_citizenID",
          "dad_phoneNumber",
          "dad_email",
          "dad_job",
        ].forEach((field) => {
          setText(`Info_${field}`, formData[field]);
        });
        setText("Info_dad_income", formatDisplayNumber(formData.dad_income));
      }

      if (formData.dad_status === "เสียชีวิต") {
        setText(
          "Info_dad_fullname_dead",
          `${formData.dad_name} ${formData.dad_surname}`
        );
      }

      // Mom info
      setText(
        "Info_mom_status",
        formData.mom_status === "มีชีวิตอยู่"
          ? "มีชีวิตอยู่"
          : formData.mom_status === "เสียชีวิต"
          ? "เสียชีวิต"
          : "ไม่ทราบ"
      );

      if (formData.mom_status === "มีชีวิตอยู่") {
        this.show_mom_info = true;
        setText(
          "Info_mom_fullname",
          `${formData.mom_name} ${formData.mom_surname}`
        );
        [
          "mom_old",
          "mom_citizenID",
          "mom_phoneNumber",
          "mom_email",
          "mom_job",
        ].forEach((field) => {
          setText(`Info_${field}`, formData[field]);
        });
        setText("Info_mom_income", formatDisplayNumber(formData.mom_income));
      }

      if (formData.mom_status === "เสียชีวิต") {
        setText(
          "Info_mom_fullname_dead",
          `${formData.mom_name} ${formData.mom_surname}`
        );
      }

      // Parent's marital status
      setText("Info_mariage_status", formData.Marital_status_of_parents);

      // Rightful guardian
      setText("Info_rightful_guardian", formData.rightful_guardian);
      if (formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา") {
        this.show_other_info = true;
        setText(
          "Info_other_fullname",
          `${formData.other_name} ${formData.other_surname}`
        );
        [
          "other_old",
          "other_citizenID",
          "other_phoneNumber",
          "other_email",
          "other_job",
          "other_relationship",
        ].forEach((field) => {
          setText(`Info_${field}`, formData[field]);
        });
        setText("Info_other_income", formatDisplayNumber(formData.other_income));
      }

      // Siblings info
      if (
        formData.siblings &&
        formData.siblings !== "null" &&
        formData.siblings !== null
      ) {
        try {
          this.siblings = JSON.parse(formData.siblings);
          console.log("Parsed siblings:", this.siblings);
        } catch (e) {
          console.error("Error parsing siblings:", e);
          this.siblings = [];
        }
      } else {
        // console.log("No siblings data found or data is null");
        this.siblings = [];
      }

      if (
        formData.user_studentType ===
        "ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร"
      ) {
        setText(
          "step5_description_header",
          "เหตุผลที่ไม่สามารถสำเร็จการศึกษาตามหลักสูตร"
        );
      } else {
        setText(
          "step5_description_header",
          "เขียนบรรยายเหตุผลถึงความจำเป็นในการขอกู้ยืมเงิน"
        );
      }

      // Description info
      this.loanDescription =
        formData.description || formData.loanDescription || "";

      // Set edit income fields from backend data
      this.editIncomes.student = formData.user_job_income ?? null;
      this.editIncomes.fan = formData.fan_income ?? null;
      this.editIncomes.dad = formData.dad_income ?? null;
      this.editIncomes.mom = formData.mom_income ?? null;
      this.editIncomes.other = formData.other_income ?? null;
    },

    // Edit Loan Status
    confirmBoxWithValue() {
      Swal.fire({
        title: "เปลี่ยนสถานะ",
        html: `<select id="swal-status" class="swal2-select text-center" style="min-width: 200px;">
        <option value="" disabled selected>-- เลือกสถานะ --</option>
        <option value="อยู่ระหว่างดำเนินการ">อยู่ระหว่างดำเนินการ</option>
        <option value="ผ่านการตรวจสอบคุณสมบัติ">ผ่านการตรวจสอบคุณสมบัติ</option>
        <option value="อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม">อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม</option>
        <option value="รอผลการพิจารณาจากกองทุน กยศ.">รอผลการพิจารณาจากกองทุน กยศ.</option>
        <option value="ตีกลับเพื่อแก้เอกสาร">ตีกลับเพื่อแก้เอกสาร</option>
        <option value="อนุมัติ">อนุมัติ</option>
        <option value="ไม่อนุมัติ">ไม่อนุมัติ</option>
      </select>
      <textarea id="swal-reason" class="swal2-textarea" placeholder="กรุณากรอกรายละเอียดเพิ่มเติม" style="margin-top: 1em;"></textarea>`,
        focusConfirm: false,
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        confirmButtonColor: "#964040",
        preConfirm: () => {
          const status = document.getElementById("swal-status").value;
          const reason = document.getElementById("swal-reason").value.trim();

          if (!status) {
            Swal.showValidationMessage("กรุณาเลือกสถานะ");
            return false;
          }
          return { status, reason };
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const { status, reason } = result.value;
          this.postBulkEditLoanStatus(this.ID, status, reason);
        }
      });
    },

    async postBulkEditLoanStatus(idArray, newStatus, reason = "") {
      // convert to Array (only this page!)
      if (!Array.isArray(idArray)) {
        idArray = [idArray];
      }

      if (!Array.isArray(idArray) || idArray.length === 0) {
        return this.$refs.alertBox.showAlert("กรุณาเลือกรายการ", "warning");
      }

      const updates = idArray.map((id) => ({
        ID: id,
        newStatus,
        reason,
      }));
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/loan/edit/status/bulk`,
          {
            method: "PATCH",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updates),
          }
        );

        if (response.ok) {
          const result = await response.json();

          const summaryLines = result.summary.map(
            (s) => `สถานะ: ${s.status} - จำนวน: ${s.changed} รายการ`
          );

          const failureLines = result.failures.map(
            (f) => `ID: ${f.ID} → ${f.reason}`
          );

          const htmlMessage = `
        <strong>📌 ผลการอัปเดตสถานะ</strong><br/>
        ${summaryLines.join("<br/>")}
        ${
          failureLines.length > 0
            ? "<br/><br/><strong>❌ รายการที่ไม่สำเร็จ:</strong><br/>"
            : ""
        }
        ${failureLines.join("<br/>")}
      `;

          await Swal.fire({
            icon: failureLines.length > 0 ? "warning" : "success",
            title: "ผลการอัปเดต",
            html: htmlMessage,
            confirmButtonText: "ปิด",
          });

          this.getLoanData(this.ID); // Refresh table
          this.checkedLoans = [];
        } else {
          const error = await response.text();
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: error,
          });
        }
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: err.message || "Unknown error",
        });
      }
    },

    getFileUrl(filePath) {
      if (!filePath || typeof filePath !== "string") return "#";
      if (!filePath.startsWith("/uploads/")) return "#";

      const baseUrl = process.env.VUE_APP_API_BASE_URL || "http://localhost:8020";
      let normalizedPath = filePath;

      // Legacy records stored files under /uploads/<filename> before the
      // backend exposed them from /uploads/loan_files/<filename>.
      if (
        normalizedPath.startsWith("/uploads/") &&
        !normalizedPath.startsWith("/uploads/loan_files/")
      ) {
        const filename = normalizedPath.split("/").pop();
        normalizedPath = filename ? `/uploads/loan_files/${filename}` : "#";
      }

      return normalizedPath === "#" ? "#" : `${baseUrl}${normalizedPath}`;
    },

    editPublicServiceNumber(field) {
      // pick correct element ID dynamically
      const publicNumber = document
        .getElementById(`Info_${field}`)
        .innerText.trim();

      Swal.fire({
        title: "แก้ไขชั่วโมงจิตสาธารณะ",
        input: "number",
        inputValue: publicNumber,
        inputLabel: "กรุณากรอกจำนวนชั่วโมงใหม่",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        confirmButtonColor: "#964040",
        preConfirm: (value) => {
          if (!value || isNaN(value) || value < 0) {
            Swal.showValidationMessage("กรุณากรอกตัวเลขที่ถูกต้อง");
          } else {
            return value;
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const newValue = result.value;
          Swal.fire({
            title: "คุณแน่ใจหรือไม่",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            confirmButtonText: "ยืนยัน",
            confirmButtonColor: "#964040",
          }).then((result) => {
            if (result.isConfirmed) {
              // pass field + value to backend
              this.patchPublicNumberLoan(field, newValue);
            }
          });
        }
      });
    },

    async patchPublicNumberLoan(field, value) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/loan/edit/public_service_hour`,
          {
            method: "PATCH",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ field, value, ID: this.ID }),
          }
        );

        if (response.ok) {
          const res = await response.json();
          this.getLoanData(this.ID);
          this.$refs.alertBox.showAlert(res, "success");
        } else {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        }
      } catch (error) {
        console.error(error.message);
        this.$refs.alertBox.showAlert(error.message, "error");
      }
    },

    editincome() {
      const incomeNumber = document
        .getElementById("Info_income")
        .innerText.trim();

      Swal.fire({
        title: "แก้ไขรายได้",
        input: "number",
        inputValue: incomeNumber,
        inputLabel: "กรุณากรอกจำนวนรายได้ใหม่",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        confirmButtonColor: "#964040",
        preConfirm: (value) => {
          if (!value || isNaN(value) || value < 0) {
            Swal.showValidationMessage("กรุณากรอกตัวเลขที่ถูกต้อง");
          } else {
            return value;
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const newValue = result.value;
          Swal.fire({
            title: "คุณแน่ใจหรือไม่",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            confirmButtonText: "ยืนยัน",
            confirmButtonColor: "#964040",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.patchincomeNumberloan(newValue);
            }
          });
        }
      });
    },

    async patchincomeNumberloan(value) {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/loan/edit/income`,
          {
            method: "PATCH",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              income: value,
              ID: this.ID,
              whose_loan: "user_job_income",
            }),
          }
        );
        if (response.ok) {
          const res = await response.json();
          this.getLoanData(this.ID);
          this.$refs.alertBox.showAlert(res, "success");
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        this.$refs.alertBox.showAlert(error.message, "error");
      }
    },

    editGPAX() {
      const currentGPAX = document
        .getElementById("Info_user_gpax") // Assuming this is the element showing GPAX
        .innerText.trim();

      Swal.fire({
        title: "แก้ไขเกรดเฉลี่ยสะสม (GPAX)",
        input: "number",
        inputValue: currentGPAX,
        inputLabel: "กรุณากรอกเกรดเฉลี่ยสะสมใหม่",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        confirmButtonColor: "#964040",
        inputAttributes: {
          step: "0.01",
          min: "0",
          max: "4",
        },
        preConfirm: (value) => {
          const num = parseFloat(value);
          if (value === "" || isNaN(num) || num < 0 || num > 4) {
            Swal.showValidationMessage(
              "กรุณากรอกเกรดเฉลี่ยสะสมที่ถูกต้อง (0 - 4)"
            );
          } else {
            return num;
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const newValue = result.value;
          Swal.fire({
            title: "คุณแน่ใจหรือไม่",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            confirmButtonText: "ยืนยัน",
            confirmButtonColor: "#964040",
          }).then((confirmation) => {
            if (confirmation.isConfirmed) {
              this.patchGPAX(newValue);
            }
          });
        }
      });
    },

    async patchGPAX(value) {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/loan/edit/gpax`,
          {
            method: "PATCH",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ gpax: value, ID: this.ID }),
          }
        );
        if (response.ok) {
          const res = await response.json();
          this.getLoanData(this.ID);
          this.$refs.alertBox.showAlert(res, "success");
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        this.$refs.alertBox.showAlert(error.message, "error");
      }
    },

    async getPDFpersonalData(publicId, user_studentID) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/download-pdf/personalData`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ public_id: publicId }), // send single string, not array
          }
        );

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || "ดาวน์โหลดไม่สำเร็จ");
        }

        const blob = await getVerifiedZipBlob(response);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `loan_form_${user_studentID}.zip`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$refs.alertBox?.showAlert("ดำเนินการดาวน์โหลด", "success");
      } catch (error) {
        console.error("Download error:", error.message);
        this.$refs.alertBox?.showAlert(error.message, "error");
      }
    },

    toggleFloatingBox() {
      this.isExpanded = !this.isExpanded;

      // Sync mobile status display
      document.getElementById("info_loan_status_mobile").innerText =
        document.getElementById("info_loan_status").innerText;
    },

    cancelEditAllIncomes() {
      // Reset values to current DOM values
      const getIncomeValue = (id) => {
        const el = document.getElementById(id);
        if (!el) return null;
        const text = el.innerText.trim();
        if (
          text &&
          text !== "-" &&
          text !== "ไม่มีข้อมูล" &&
          !isNaN(parseFloat(text))
        ) {
          return parseFloat(text);
        }
        return null;
      };
      this.editIncomes.student = getIncomeValue("Info_income");
      this.editIncomes.fan = getIncomeValue("Info_fan_income");
      this.editIncomes.dad = getIncomeValue("Info_dad_income");
      this.editIncomes.mom = getIncomeValue("Info_mom_income");
      this.editIncomes.other = getIncomeValue("Info_other_income");
    },
    async saveAllIncomes() {
      const updates = [];
      const getIncomeValue = (id) => {
        const el = document.getElementById(id);
        if (!el) return null;
        const text = el.innerText.trim();
        if (
          text &&
          text !== "-" &&
          text !== "ไม่มีข้อมูล" &&
          !isNaN(parseFloat(text))
        ) {
          return parseFloat(text);
        }
        return null;
      };
      const current = {
        student: getIncomeValue("Info_income"),
        fan: getIncomeValue("Info_fan_income"),
        dad: getIncomeValue("Info_dad_income"),
        mom: getIncomeValue("Info_mom_income"),
        other: getIncomeValue("Info_other_income"),
      };
      if (
        this.editIncomes.student !== null &&
        this.editIncomes.student !== current.student
      )
        updates.push({
          income: this.editIncomes.student,
          whose_loan: "user_job_income",
        });
      if (this.editIncomes.fan !== null && this.editIncomes.fan !== current.fan)
        updates.push({
          income: this.editIncomes.fan,
          whose_loan: "fan_income",
        });
      if (this.editIncomes.dad !== null && this.editIncomes.dad !== current.dad)
        updates.push({
          income: this.editIncomes.dad,
          whose_loan: "dad_income",
        });
      if (this.editIncomes.mom !== null && this.editIncomes.mom !== current.mom)
        updates.push({
          income: this.editIncomes.mom,
          whose_loan: "mom_income",
        });
      if (
        this.editIncomes.other !== null &&
        this.editIncomes.other !== current.other
      )
        updates.push({
          income: this.editIncomes.other,
          whose_loan: "other_income",
        });
      if (updates.length === 0) {
        this.$refs.alertBox.showAlert("คุณไม่ได้แก้ไขข้อมูลรายได้", "info");
        return;
      }
      let success = 0,
        fail = 0,
        failList = [];
      for (const upd of updates) {
        try {
          const response = await fetch(
            `${process.env.VUE_APP_API_BASE_URL}/staff/loan/edit/income`,
            {
              method: "PATCH",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                income: upd.income || 0,
                ID: this.ID,
                whose_loan: upd.whose_loan,
              }),
            }
          );
          if (response.ok) {
            success++;
          } else {
            fail++;
            const err = await response.text();
            failList.push(`${upd.whose_loan}: ${err}`);
          }
        } catch (e) {
          fail++;
          failList.push(`${upd.whose_loan}: ${e.message}`);
        }
      }
      this.getLoanData(this.ID);
      if (fail > 0) {
        this.$refs.alertBox.showAlert(
          `อัปเดตรายได้สำเร็จ ${success} รายการ\nไม่สำเร็จ ${fail} รายการ:\n${failList.join(
            "\n"
          )}`,
          "warning"
        );
      } else {
        this.$refs.alertBox.showAlert(
          `อัปเดตรายได้สำเร็จ ${success} รายการ`,
          "success"
        );
      }
    },

    formatNumber(val) {
      if (val === null || val === undefined || val === "") return "";
      return Number(val).toLocaleString();
    },
    formatManagedByName(value) {
      return formatEmailDisplayName(value);
    },
    onIncomeInput(e, field) {
      let raw = e.target.value.replace(/,/g, "").replace(/[^\d]/g, "");
      this.editIncomes[field] = raw ? Number(raw) : 0;
    },
  },

  mounted() {
    const queryId = this.$route.query.id;
    if (queryId) {
      this.ID = queryId;
      this.getLoanData(queryId);
    } else {
      this.$router.replace("/staff");
    }
  },

  beforeUnmount() {},

  watch() {},
};
</script>

<style scoped>
.red-circle {
  position: absolute;
  width: 100%;
  height: 40%;
  background-color: #964040;
  z-index: -1;
}

/* To Make Sure h1-h6 don't have extended space */
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}

.con-header {
  color: white;
  background-color: #964040;
}

.screen-control {
  height: 100vh;
  min-height: 100%;
  padding: 5rem 20vw;
}

.public-service-total-row__label {
  padding-left: 0.75rem;
}

.public-service-total-row__label,
.public-service-total-row__value {
  margin-bottom: 0;
}

.public-service-total-row__value {
  white-space: nowrap;
}

.pdf-summary {
  border-radius: 12px;
}

.pdf-summary__title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #964040;
  margin-bottom: 1rem;
}

.pdf-summary__display-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #212529;
  white-space: pre-line;
  text-align: center;
  margin-bottom: 1rem;
}

.pdf-summary__section + .pdf-summary__section {
  margin-top: 1.25rem;
}

.pdf-summary__header {
  font-size: 1rem;
  font-weight: 700;
  color: #343a40;
  margin-bottom: 0.75rem;
}

.pdf-summary__pairs {
  display: grid;
  gap: 0.75rem;
}

.pdf-summary__pair {
  display: grid;
  grid-template-columns: minmax(220px, 320px) 1fr;
  gap: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.pdf-summary__label {
  font-weight: 700;
  color: #495057;
}

.pdf-summary__value,
.pdf-summary__textblock p,
.pdf-summary__lines p {
  color: #212529;
  white-space: pre-wrap;
  word-break: break-word;
}

.pdf-summary__textblock {
  display: grid;
  gap: 0.5rem;
}

.pdf-summary__separator {
  margin: 1.25rem 0;
  border-top: 2px dashed rgba(150, 64, 64, 0.3);
}

#floating-box {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 320px;
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  font-family: sans-serif;
  z-index: 9999;
  overflow: hidden;
  transition: all 0.3s ease;
}

#floating-header {
  background-color: #e1e1e1;
  color: white;
  padding: 10px 15px;
  cursor: pointer;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

#floating-content {
  padding: 10px 15px;
  background-color: #fff;
  font-size: 0.95rem;
  word-wrap: break-word;
}

/* Fold arrow rotation */
#toggle-arrow {
  transition: transform 0.3s ease;
}

#toggle-arrow.rotated {
  transform: rotate(180deg);
}

/* Fold transition */
.fold-enter-active,
.fold-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.fold-enter-from,
.fold-leave-to {
  max-height: 0;
  opacity: 0;
}

.fold-enter-to,
.fold-leave-from {
  max-height: 500px;
  opacity: 1;
}

/* Responsive behavior */
@media (max-width: 768px) {
  .screen-control {
    padding: 5rem 5vw;
  }

  .pdf-summary__pair {
    grid-template-columns: 1fr;
  }

  #floating-box {
    right: 5%;
    bottom: 20px;
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 50%;
    overflow: hidden;
    transition: all 0.3s ease;
  }

  #floating-box.floating-box--collapsed #floating-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 100%;
  }

  #floating-box.floating-box--collapsed .header-label,
  #floating-box.floating-box--collapsed .status-text {
    display: none !important;
  }

  #floating-box.floating-box--collapsed #toggle-arrow {
    margin-left: 11px;
  }

  #floating-box:not(.floating-box--collapsed) {
    width: 90%;
    height: auto;
    border-radius: 10px;
  }

  #floating-header {
    padding: 10px;
    height: auto;
    display: flex;
    align-items: center;
  }
}
</style>
